import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';

import { PairGameNoScoreboardComponent } from './pair-game-no-scoreboard.component';
import { PairGameScoreboardComponent } from './pair-game-scoreboard.component';
import { ScoreboardResolveService, ScoreboardViewType } from './scoreboard-resolve.service';
import { SetGameScoreboardComponent } from './set-game-scoreboard.component';
import { TournamentScoreboardComponent } from './tournament-scoreboard.component';

@Component({
    selector: 'ms-scoreboard',
    templateUrl: './scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PairGameNoScoreboardComponent, PairGameScoreboardComponent, SetGameScoreboardComponent, TournamentScoreboardComponent],
})
export class ScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() showSportIcon = false;
    @HostBinding('class') className = 'card-scoreboard-host';

    view: ScoreboardViewType;
    viewType = ScoreboardViewType;

    constructor(private scoreboardResolver: ScoreboardResolveService) {}

    ngOnChanges(): void {
        this.view = this.scoreboardResolver.getComponent(this.event);
    }
}
